import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import Pages from "./pages";
import UserDetails from "./pages/users/details";
import UsersForm from "./pages/users/form/usersForm";
import { useAppDispatch } from "./hooks/store";
import { useEffect } from "react";
import { STORAGE_KEYS, getFromStorage } from "./constants";
import { resetAuth, setCredentials } from "./reducers/authSlice";

const hasToken = () => Boolean(getFromStorage(STORAGE_KEYS.token));

const PublicRoute = () =>
  hasToken() ? <Navigate to="/dashboard" replace /> : <Outlet />;

const PrivateRoute = () =>
  hasToken() ? <Outlet /> : <Navigate to="/" replace />;

const Routing = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    const token = getFromStorage(STORAGE_KEYS.token);

    if (token) {
      dispatch(
        setCredentials({
          token: `${token}`,
          user: null,
        })
      );
      return;
    }

    dispatch(resetAuth());
  }, [dispatch]);

  const fallbackPath = hasToken() ? "/dashboard" : "/";

  return (
    <Routes>
      <Route element={<PublicRoute />}>
        <Route path="/" element={<Pages.LoginPage />} />
        <Route path="forgotpassword" element={<Pages.ForgotPasswordPage />} />
        <Route path="verifyotp" element={<Pages.VerifyOtp />} />
        <Route path="resetpassword" element={<Pages.ResetPassword />} />
      </Route>

      <Route element={<PrivateRoute />}>
        <Route path="/changepassword" element={<Pages.ChangePassword />} />
        <Route path="/dashboard" element={<Pages.DashBoardPage />} />
        <Route path="/profile" element={<Pages.Profile />} />
        <Route path="/manageusers" element={<Pages.ManageUsers />} />
        <Route path="/feedback-users" element={<Pages.FeedbackUsers />} />
        <Route
          path="/FeedbackUsers"
          element={<Navigate to="/feedback-users" replace />}
        />
        <Route path="/manageusers/userdetails/:id" element={<UserDetails />} />
        <Route path="/manageusers/usersform/:id" element={<UsersForm />} />
        <Route path="/analytics" element={<Pages.Analytics />} />
        <Route path="/faq" element={<Pages.Faq />} />
        <Route path="/cms" element={<Pages.ManageCms />} />
        <Route path="/settings" element={<Pages.Settings />} />
        <Route path="/manage-banner" element={<Pages.ManageBanner />} />
        <Route path="/manage-banner/add" element={<Pages.AddBanner />} />
        <Route path="/manage-banner/edit/:id" element={<Pages.AddBanner />} />
        <Route
          path="/manage-subscription"
          element={<Pages.ManageSubscription />}
        />
        <Route
          path="/manage-subscription/add"
          element={<Pages.AddSubscriptionPlan />}
        />
        <Route
          path="/manage-subscription/edit/:id"
          element={<Pages.AddSubscriptionPlan />}
        />
        <Route
          path="/manage-notifications"
          element={<Pages.ManageNotifications />}
        />
        <Route
          path="/manage-notifications/add"
          element={<Pages.AddNotification />}
        />
        <Route
          path="/manage-notifications/details/:id"
          element={<Pages.NotificationDetails />}
        />
        <Route
          path="/recieved-notifications"
          element={<Pages.RecievedNotifications />}
        />
        <Route path="/manage-subAdmin" element={<Pages.ManageSubAdmin />} />
        <Route path="/manage-subAdmin/add" element={<Pages.AddSubAdmin />} />
        <Route
          path="/manage-subAdmin/edit/:id"
          element={<Pages.AddSubAdmin />}
        />
        <Route path="/manage-categories" element={<Pages.ManageCategories />} />
        <Route path="/manage-categories/add" element={<Pages.AddCategories />} />
        <Route
          path="/manage-categories/edit/:id"
          element={<Pages.AddCategories />}
        />
        <Route
          path="/manage-categories/details/:id"
          element={<Pages.SubCategories />}
        />
        <Route path="/manage-emails" element={<Pages.ManageEmail />} />
        <Route
          path="/set-points-criteria"
          element={<Pages.SetPointsCriteria />}
        />
        <Route path="/manage-round-up" element={<Pages.ManageRoundUp />} />
        <Route
          path="/manage-savings-limit"
          element={<Pages.ManageSavingsLimit />}
        />
        <Route path="/permission-denied" element={<Pages.PermissionDenied />} />
      </Route>

      <Route path="*" element={<Navigate to={fallbackPath} replace />} />
    </Routes>
  );
};

export default Routing;
